import {useCallback} from 'react';
import AnalyticsService, {
  eventNames,
} from '@/services/analytics/AnalyticsService';

type StoreViewPresentedEventParams = {
  flow_id?: string;
  presentation_id: string;
  reason?: string;
  view_details?: string;
  view_name: string;
  view_type: string;
};

function useStoreViewPresentedEvent(flowName?: string) {
  const storeViewPresented = useCallback(
    ({
      flow_id = '',
      presentation_id,
      reason = '',
      view_details = '',
      view_name,
      view_type,
    }: StoreViewPresentedEventParams) => {
      const flow = flowName ? AnalyticsService.getFlow(flowName) : undefined;
      AnalyticsService.dispatchEvent(
        eventNames.CONTENT_STUDIO_STORE_VIEW_PRESENTED,
        {
          flow_id: flow?.flow_id || flow_id,
          presentation_id,
          reason,
          view_details,
          view_name,
          view_type,
        }
      );
    },
    []
  );

  return {storeViewPresented};
}

export default useStoreViewPresentedEvent;
